import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getRoleList } from "reduxStore/action/roleActions";
import strings from "translate/language";
import TableDataNotFound from "component/TableDataNotFound";
import { errorToast, successToast } from "utils/httpClient";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import usePermission from "utils/usePermission";
import {
  channelPartnerSlug,
  channelPartnerUserType,
  cpAgentSlug,
} from "utils/constants";

const Roles = () => {
  const navigate = useNavigate();
  const [roleList, setRoleList] = useState([]);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const getRoleListSelector = useSelector((state) => state.roleData) || {};

  const { create, edit } = usePermission({
    create: "add_role",
    edit: "edit_role",
  });
  useLayoutEffect(() => {
    dispatch(getRoleList());
  }, []);

  useEffect(() => {
    if (getRoleListSelector?.response) {
      if (getRoleListSelector?.response?.status === 200) {
        if (getRoleListSelector?.create) {
          successToast(getRoleListSelector?.response?.message);
        }
        setRoleList(
          handleListResponse(getRoleListSelector?.response?.data)
            ? getRoleListSelector?.response?.data
            : []
        );
      } else {
        errorToast(getRoleListSelector?.response?.message);
      }
    }
  }, [getRoleListSelector]);
  useEffect(() => {
    seo({
      title: "Role Listing",
      metaDescription: "Role listing",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb title={strings.role} titleactive={strings.roleListing} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            {create && (
              <div className="row pt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <Button
                      className="btn btn-color"
                      onClick={() => navigatpage("/addnewroles")}
                      label={strings.addNewrole}
                    ></Button>
                  </div>
                </div>
                <div className="col-md-6 "></div>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfRole}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.sno}</th>
                          <th scope="col">{strings.roles}</th>
                          <th scope="col">{strings.total_users}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {roleList.length > 0 ? (
                          roleList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.role_title}</td>
                                <td>
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      // if we use ternary ? in url so that type url is query params
                                      const _id = item._id;
                                      if (
                                        item.slug === channelPartnerSlug ||
                                        item.slug === cpAgentSlug
                                      ) {
                                        let userType =
                                          item.slug === channelPartnerSlug
                                            ? channelPartnerUserType.cp
                                            : channelPartnerUserType.agent;
                                        navigatpage(
                                          `/channelpartner?role_id=${_id}&user_type=${userType}`
                                        );
                                      } else {
                                        navigatpage(`/user?role_id=${_id}`);
                                      }
                                    }}
                                  >
                                    {item.total_user}
                                  </a>
                                </td>
                                {edit && (
                                  <td>
                                    <Button
                                      className="btn btn-dark"
                                      onClick={() =>
                                        navigatpage(`/editroles/${item._id}`)
                                      }
                                      label={strings.edit}
                                    ></Button>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr></tr>
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={roleList} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Roles;
